import { render, staticRenderFns } from "./ScoreStart.vue?vue&type=template&id=51e6910f&scoped=true&"
import script from "./ScoreStart.vue?vue&type=script&lang=js&"
export * from "./ScoreStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6910f",
  null
  
)

export default component.exports